import { jsxs, jsx } from "react/jsx-runtime";
import "react";
import PropTypes from "prop-types";
const Chart = ({
  title,
  className,
  titleClassName,
  svgClassName,
  children,
  height,
  width
}) => /* @__PURE__ */ jsxs("div", { className, "aria-hidden": "true", children: [
  title && /* @__PURE__ */ jsx("h4", { className: titleClassName, children: title }),
  /* @__PURE__ */ jsx("svg", { className: svgClassName, height, width, children })
] });
Chart.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  height: PropTypes.node,
  svgClassName: PropTypes.string,
  title: PropTypes.node,
  titleClassName: PropTypes.string,
  width: PropTypes.node,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  legend: PropTypes.bool
};
Chart.defaultProps = {
  title: "",
  className: "rd3-basic-chart",
  svgClassName: "rd3-chart",
  titleClassName: "rd3-chart-title",
  legend: false
};
export {
  Chart as default
};
